import { PAGE_COUNT } from '../constants/app-constants';

const getCount = (filterStatus, value, group) => {
  let count = 0;
  if (Object.keys(filterStatus).length) {
    const countZone = filterStatus[group];
    count = countZone.items[value];
  }
  return count;
};
const groupArray = ({
  filterCriteria = {}, filterStatus = {},
}) => {
  const data = [];
  if (Object.keys(filterStatus).length && Array.isArray(filterCriteria)) {
    filterCriteria.forEach((firstLevelCriteria) => {
      const values = firstLevelCriteria.values.map(({ value, group }) => ({
        value,
        group,
        count: getCount(filterStatus, value, group),
      }));
      data.push({ group: firstLevelCriteria.group, values });
    });
  } else {
    Object.keys(filterCriteria).forEach((firstLevelCriteria) => {
      const values = filterCriteria[firstLevelCriteria].map((secondLevelCriteria) => ({
        group: firstLevelCriteria,
        value: secondLevelCriteria,
      }));
      data.push({ group: firstLevelCriteria, values });
    });
  }
  return data;
};
const normalize = (v = '') => v.toString().toLowerCase().replace(/\(.*?\)/g, '').trim();

const getAppliedData = ({
  filterCriteria, name, appliedFilter, isGroup = true,
  selectedFilter,
}) => {
  if (Array.isArray(filterCriteria)) {
    // const isAppliedFilter = (appliedData, option) => appliedData.some((s) => (s === option.value) || (s && s.value === option.value));
    const isAppliedFilter = (appliedData, option) => appliedData.some((s) => normalize(typeof s === 'object' ? s.value : s) === normalize(option.value));
    filterCriteria.forEach((item) => {
      if (isGroup) {
        item.values.forEach((elm) => {
          if (isAppliedFilter(appliedFilter[name], elm) && elm.value && isGroup) {
            selectedFilter[name].push({ value: elm.value, group: elm.group, count: elm.count || 0 });
          }
        });
      }
      if (isAppliedFilter(appliedFilter[name], item) && item.value && !isGroup) {
        selectedFilter[name].push({ value: item.value, count: item.count || 0 });
      }
    });
  }
};
const getAppliedFilter = (props) => {
  const {
    filters = [],
    appliedFilter = {
      search: '', locations: [], services: [], solutions: [], languages: [], specializations: [], affiliations: [], offerings: [],
    },
  } = props || {};
  const selectedFilter = {
    locations: [], services: [], solutions: [], languages: [], search: '', specializations: [], affiliations: [], offerings: [],
  };
  getAppliedData({
    filterCriteria: filters?.locations || [], name: 'locations', appliedFilter, selectedFilter,
  });
  getAppliedData({
    filterCriteria: filters?.services || [], name: 'services', appliedFilter, selectedFilter,
  });
  getAppliedData({
    filterCriteria: filters?.solutions || [], name: 'solutions', appliedFilter, selectedFilter,
  });
  getAppliedData({
    filterCriteria: filters?.languages || [], name: 'languages', appliedFilter, selectedFilter, isGroup: false,
  });
  getAppliedData({
    filterCriteria: filters?.specializations || [], name: 'specializations', appliedFilter, selectedFilter,
  });
  getAppliedData({
    filterCriteria: filters?.affiliations || [], name: 'affiliations', appliedFilter, selectedFilter,
  });
  getAppliedData({
    filterCriteria: filters?.offerings || [], name: 'offerings', appliedFilter, selectedFilter, isGroup: false,
  });
  selectedFilter.search = appliedFilter.search || '';
  selectedFilter.pageCount = appliedFilter.pageCount;
  selectedFilter.pageNumber = appliedFilter.pageNumber;
  return selectedFilter;
};
const getFormattedGroupArray = (object) => {
  const {
    filters = {}, filterStatus = {},
  } = object || {};
  const filterObject = {};
  filterObject.locations = groupArray({
    filterCriteria: filters.locations || {}, filterStatus: filterStatus?.locations || {}, name: 'locations',
  });
  filterObject.services = groupArray({
    filterCriteria: filters?.services || {}, filterStatus: filterStatus?.services || {}, name: 'services',
  });
  filterObject.solutions = groupArray({
    filterCriteria: filters?.solutions || {}, filterStatus: filterStatus?.solutions || {}, name: 'solutions',
  });
  filterObject.specializations = groupArray({
    filterCriteria: filters?.specializations || {}, filterStatus: filterStatus?.specializations || {}, name: 'specializations',
  });
  filterObject.languages = [];
  if (filters && filters.languages && filters.languages.length) {
    filters.languages.forEach((language) => {
      let count = 0; let value = '';
      if (filterStatus.languages && Object.keys(filterStatus.languages).length) {
        if (typeof language === 'object') {
          value = language.value;
        } else if (typeof language === 'string') {
          value = language;
        }
        count = filterStatus.languages[value];
      } else {
        value = language;
      }
      filterObject.languages.push({ value, count });
    });
  }
  filterObject.affiliations = groupArray({
    filterCriteria: filters.autodesk_affiliations || {}, filterStatus: filterStatus?.affiliations || {}, name: 'affiliations',
  });
  filterObject.offerings = [];
  if (filters && filters.offerings && filters.offerings.length) {
    filters.offerings.forEach((offering) => {
      let count = 0; let value = '';
      if (filterStatus.offerings && Object.keys(filterStatus.offerings).length) {
        if (typeof offering === 'object') {
          value = offering.value;
        } else if (typeof offering === 'string') {
          value = offering;
        }
        count = filterStatus.offerings[value];
      } else {
        value = offering;
      }
      filterObject.offerings.push({ value, count });
    });
  }
  return { filters: filterObject };
};

const getData = (data, name) => data.map((item) => item[name]).toString();

const getSelectedFilter = (filter) => {
  const {
    languages = [], locations = [], services = [], solutions = [], pageCount, pageNumber, search = '',
    specializations = [], affiliations = [], offerings = [],
  } = filter;
  const lang = ((languages.length) ? getData(languages, 'value') : '');
  const location = ((locations.length) ? getData(locations, 'value') : '');
  const solution = ((solutions.length) ? getData(solutions, 'value') : '');
  const service = ((services.length) ? getData(services, 'value') : '');
  const specialization = ((specializations.length) ? getData(specializations, 'value') : '');
  const affiliation = ((affiliations.length) ? getData(affiliations, 'value') : '');
  const offering = ((offerings.length) ? getData(offerings, 'value') : '');
  return {
    lang, location, solution, service, pageCount, pageNumber, specialization, search, affiliation, offering,
  };
};
const isFilterSelected = (filter) => {
  const {
    lang = '', location = '', solution = '', service = '', search = '', specialization = '', affiliation = '', offering = '',
  } = getSelectedFilter(filter);
  return lang || location || solution || service || specialization || search || affiliation || offering;
};

// eslint-disable-next-line consistent-return
const getSRPSearchPayLoad = (filter, query = false, sortBy) => {
  const {
    lang = '', location = '', solution = '', service = '', specialization = '', pageCount = PAGE_COUNT, pageNumber = 1, search = '', affiliation = '', offering = '',
  } = getSelectedFilter(filter);
  const param = `${search ? `&search=${encodeURIComponent(search)}` : ''}${location && `&locations=${encodeURIComponent(location)}`}${lang && `&languages=${encodeURIComponent(lang)}`}${solution && `&solutions=${encodeURIComponent(solution)}`}${service && `&services=${encodeURIComponent(service)}`}${specialization && `&specializations=${encodeURIComponent(specialization)}`}${affiliation && `&autodesk_affiliations=${encodeURIComponent(affiliation)}`}${offering && `&offerings=${encodeURIComponent(offering)}`}`;
  if (query) {
    return param.trim() ? `?${param}`.replace('?&', '?') : '';
  } if (!query) {
    return `page_count=${pageCount}&page_no=${pageNumber}&sort_by=${sortBy}${param}`;
  }
};
const getSRPURLSearchParams = (queryParam) => {
  const getDataArray = (data) => data.split(/,(?!\s)/) || [];
  const locations = queryParam.get('locations');
  const languages = queryParam.get('languages');
  const services = queryParam.get('services');
  const solutions = queryParam.get('solutions');
  const specializations = queryParam.get('specializations');
  const affiliations = queryParam.get('autodesk_affiliations');
  const offerings = queryParam.get('offerings');
  const filters = {
    languages: languages ? getDataArray(languages) : [],
    locations: locations ? getDataArray(locations) : [],
    solutions: solutions ? getDataArray(solutions) : [],
    services: services ? getDataArray(services) : [],
    specializations: specializations ? getDataArray(specializations) : [],
    affiliations: affiliations ? getDataArray(affiliations) : [],
    offerings: offerings ? getDataArray(offerings) : [],
    search: queryParam.get('search') || '',
  };
  return filters;
};
const getAPIParams = (param) => {
  const searchParam = new URLSearchParams(param);
  const keys = Array.from(searchParam.keys());
  keys.forEach((key) => {
    if (key !== 'page_count' && key !== 'page_no') {
      const valueList = searchParam.get(key);
      searchParam.delete(key);
      valueList.split(',').forEach((value) => {
        searchParam.append(key, value);
      });
    }
  });
  return searchParam.toString();
};

const formatLabel = (str) => str.split('_').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

export {
  getAppliedFilter,
  getFormattedGroupArray,
  getSRPSearchPayLoad,
  getSelectedFilter,
  isFilterSelected,
  getSRPURLSearchParams,
  getAPIParams,
  formatLabel,
};
